// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ReloadSvg from '@rsuite/icon-font/lib/action/Reload';
var Reload = createSvgIcon({
  as: ReloadSvg,
  ariaLabel: 'reload',
  category: 'action',
  displayName: 'Reload'
});
export default Reload;